import SVG from 'react-inlinesvg';
import { useId } from 'react';

interface SVGIconProps {
  src: string;
  className?: string;
  iconColor?: string;
  fillColor?: string;
  strokeWidth?: string;
  width?: number;
  height?: number;
}

export default function SVGIcon({
  src,
  className,
  iconColor,
  fillColor,
  strokeWidth,
  width,
  height,
}: SVGIconProps) {
  const uniqueId = `svg-${useId().replace(/:/g, '')}`;

  return (
    <>
      {(iconColor || fillColor || strokeWidth) && (
        <style>
          {`
            ${iconColor ? `.${uniqueId} path { stroke: ${iconColor} !important; } .${uniqueId} circle { stroke: ${iconColor} !important; } .${uniqueId} ellipse { stroke: ${iconColor} !important; }` : ''}
            ${fillColor ? `.${uniqueId} path { fill: ${fillColor} !important; } .${uniqueId} circle { fill: ${fillColor} !important; } .${uniqueId} ellipse { fill: ${fillColor} !important; }` : ''}
            ${strokeWidth ? `.${uniqueId} path { stroke-width: ${strokeWidth} !important; } .${uniqueId} circle { stroke-width: ${strokeWidth} !important; } .${uniqueId} ellipse { stroke-width: ${strokeWidth} !important; }` : ''}
          `}
        </style>
      )}
      <SVG src={src} className={`${className} ${uniqueId}`} width={width} height={height} />
    </>
  );
}
